<template>
  <div class="hub-details">

    <div class="md-layout">
      <div class="md-layout-item md-size-25 md-medium-size-30">
        <div class="hub-image-wrapper">
          <img :src="getHubImage" alt="Current Hub">
        </div>
      </div>
      <div class="md-layout-item hub-main-info">
        <div class="hub-title md-title">{{ hubName }}</div>
        <div>{{ $t('HUB_DETAILS.HEADER.DESCRIPTION') }}</div>
        <div class="md-body-1">{{ trackingNumber }}</div>
      </div>
    </div>

    <div class="md-layout top-margin-35">
      <div class="md-layout-item md-size-15 md-xsmall-size-25">
        <md-icon class="icon">access_time</md-icon>
      </div>
      <div class="md-layout-item">
        <div> {{ $t('HUB_DETAILS.OPENING_TIMES') }}</div>
        <div class="top-margin-5">
          <div v-if="hubDetails.info.weekWorkingHours"><time class="md-caption">{{ hubDetails.info.weekWorkingHours }}</time></div>
          <div v-if="hubDetails.info.weekendWorkingHours"><time class="md-caption">{{ hubDetails.info.weekendWorkingHours }}</time></div>
        </div>
      </div>
    </div>

    <div class="md-layout top-margin-35">
      <div class="md-layout-item md-size-15 md-xsmall-size-25">
        <md-icon v-if="hubDetails.info.phoneNumber" class="icon">call</md-icon>
        <md-icon v-else class="icon">place</md-icon>
      </div>
      <div class="md-layout-item">
        <div> {{ $t('HUB_DETAILS.CONTACT_INFORMATION') }}</div>
        <div class="top-margin-5">
          <div class="md-caption" v-if="hubDetails.info.phoneNumber">{{ hubDetails.info.phoneNumber }}</div>
          <div class="md-caption" v-if="hubDetails.info.address && hubDetails.info.address.street">{{ addressDetails }}</div>
        </div>
      </div>
    </div>

    <div class="md-layout top-margin-35">
      <div class="md-layout-item md-size-15 md-xsmall-size-25">
        <md-icon class="icon">fingerprint</md-icon>
      </div>
      <div class="md-layout-item">
        <div> {{ $t('HUB_DETAILS.EVENTS') }}</div>
        <div>
          <div class="event-entry" v-for="event in eventsReversed" :key="event.date">
            <div class="md-caption">{{ event.label }}</div>
            <div class="md-caption">{{ event.date | formateDate }}</div>
          </div>
          <div class="md-caption" v-if="!hubDetails.events || hubDetails.events.length === 0"> {{ $t('HUB_DETAILS.NO_EVENTS') }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'HubDetails',
  props: {
    trackingNumber: {
      type: String,
      required: true
    },
    hubDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
    hubName () {
      return this.hubDetails.info.commercialLabel || this.hubDetails.info.name
    },
    addressDetails () {
      const notAvailable = 'Not available'

      let address = ''
      if (this.hubDetails.info.address.street) {
        address += this.hubDetails.info.address.street
      }
      if (this.hubDetails.info.address.city && this.hubDetails.info.address.city !== notAvailable) {
        address += ', ' + this.hubDetails.info.address.city
      }
      if (this.hubDetails.info.address.country && this.hubDetails.info.address.country !== notAvailable) {
        address += ', ' + this.hubDetails.info.address.country
      }
      return address
    },
    getHubImage () {
      const image = this.hubDetails.position === 'CURRENT' ? 'current-hub.png'
        : this.hubDetails.position === 'FUTURE' ? 'future-hub.svg' : 'previous-hub.svg'
      return require(`@/assets/images/markers/details/${image}`)
    },
    eventsReversed () {
      return this.hubDetails.events.slice().reverse()
    }
  },
  filters: {
    formateDate: function (value) {
      if (value) {
        return moment(value).format('HH:mm, DD/MM/YYYY')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.top-margin-35
  margin-top: 35px
.top-margin-5
  margin-top: 5px

.event-entry:not(:first-of-type)
  margin-top: 10px
.event-entry:first-of-type
  margin-top: 5px

.icon
  float: right
  margin-right: 30px

.hub-title
  margin: 12px 0 10px 0

.hub-image-wrapper
  margin: 0 auto
  text-align: left
  img
    object-fit: cover
    width: 100px
    height: 100px
    @media (max-width: $small-device-width)
      width: 75px
      height: 75px
      margin-top: 15px
.hub-main-info
  @media (max-width: $small-device-width)
    padding-left: 10px
</style>
